import { gql } from "@apollo/client"
import { KeyValuePair } from "./EledoPlanState"
import { EledoAccountMembers } from "./EledoAccountMemberQueries"

export type EledoAccount = {
  id?: string
  name?: string
  locale?: string
  timezone?: string
  language?: string
  countryCode?: string
  profile?: EledoAccountProfile
  notifications?: EledoNotificationsConfig
  members?: EledoAccountMembers
}

export type EledoAccountProfile = {
  properties: KeyValuePair[]
  counters: KeyValuePair[]
  autoActivate: boolean
}

export type EledoNotificationsConfig = {
	warnLimit80: boolean
	warnLimit100: boolean
	paymentReceived: boolean
	opsEmail: string
	paymentEmail: string
	paymentPDFAttachment: boolean
	helpdeskReply: boolean
	monthlyReport: boolean
}

export type EledoAccountVars = {
  id?: string
}

export type EledoAccountData = {
  account: EledoAccount
}

export type EledoAccountInput = {
  name?: string
  locale?: string
  timezone?: string
  language?: string
  countryCode?: string
  profile?: EledoAccountProfileInput
  notifications?: EledoNotificationsConfigInput
}

export type EledoAccountProfileInput = {
  properties: KeyValuePair[]
  counters: KeyValuePair[]
  autoActivate: boolean
}

export type EledoNotificationsConfigInput = {
	warnLimit80: boolean
	warnLimit100: boolean
	paymentReceived: boolean
	opsEmail: string
	paymentEmail: string
	paymentPDFAttachment: boolean
	helpdeskReply: boolean
	monthlyReport: boolean
}

export type UpdateEledoAccountVars = {
  account: EledoAccount
}

export type UpdateEledoAccountData = {
  updateAccount: EledoAccount
}

export const GET_ELEDO_ACCOUNT = gql`
  query getAccount {
    account { id name locale timezone language countryCode profile { properties { key value } counters { key value } autoActivate }
      notifications { warnLimit80 warnLimit100 paymentReceived opsEmail paymentEmail paymentPDFAttachment helpdeskReply monthlyReport }
      
    }
  }
`;

export const UPDATE_ELEDO_ACCOUNT = gql`
  mutation updateAccount($account: EledoAccountInput) {
    updateAccount(account: $account) { id name locale timezone language countryCode profile { properties { key value } counters { key value } autoActivate }
      notifications { warnLimit80 warnLimit100 paymentReceived opsEmail paymentEmail paymentPDFAttachment helpdeskReply monthlyReport }
    }
  }
`;